var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import HelpSide from './Help/HelpSide.vue';
import { on, off } from '@/utils/dom';
import { isArray } from '@lhb/func';
var CrmLayout = /** @class */ (function (_super) {
    __extends(CrmLayout, _super);
    function CrmLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.helpSideShow = false;
        _this.helpSideProps = null;
        return _this;
    }
    CrmLayout.prototype.mounted = function () {
        on(document, 'mousedown', this.handleDocumentClick);
    };
    CrmLayout.prototype.beforeDestroy = function () {
        off(document, 'mousedown', this.handleDocumentClick);
    };
    /**
       * 控制导航管理隐藏
       */
    CrmLayout.prototype.handleDocumentClick = function (e) {
        if (isArray(e.target.className) && e.target.className.includes('wk-icon-fill-help')) {
            var type = e.target.dataset.type;
            var id = e.target.dataset.id;
            if (type && id) {
                this.helpSideProps = {
                    menuIndex: 'Question',
                    type: parseInt(type),
                    id: parseInt(id)
                };
                this.helpSideShow = true;
            }
        }
        if (isArray(e.target.className) && e.target.className.includes('wk-premium-info')) {
            var type = e.target.dataset.type;
            var force = e.target.dataset.force; // 如果等于1 强制查看
            if (type) {
                // 如果已经开启不查看简介 也就是数量大于0
                if (type === 'BusinessInformation' && force !== '1') {
                    var enterprise = this.moduleData.find(function (item) { return item.module === 'enterprise'; });
                    if (enterprise.number > 0) {
                        return;
                    }
                }
                this.appSideProps = {
                    type: type
                };
                this.appreciationSideShow = true;
            }
        }
    };
    CrmLayout = __decorate([
        Component({
            components: {
                HelpSide: HelpSide
            }
        })
    ], CrmLayout);
    return CrmLayout;
}(Vue));
export default CrmLayout;
